import React from 'react';

const RequiredFieldSign = (props) => {
    return <span className='col-mapping-required-sign'>{props.requiredData.length === 0 ? '*' : ' '}</span>;
}

export default RequiredFieldSign

